const BASE_URL = `${window.location.protocol}//${window.location.host}`;

export async function getAll(filters = {}, fields = '') {
    const query = new URLSearchParams();

    if (filters.name) { query.append('name', filters.name); }

    if (fields) { query.append('fields', fields); }
    
    const queryString = query.toString();
    const url = queryString 
    ? `${BASE_URL}/api/administration/accessUserGroup?${queryString}`
    : `${BASE_URL}/api/administration/accessUserGroup`

    const res = await fetch(url, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
    });

    const text = await res.text();

    let data = null;

    try {
        data = text ? JSON.parse(text) : null;
    }
    catch {
        data = null;
    }

    if (!res.ok) {
        throw new Error(`Failed to fetch users: ${res.status}`);
    }

    return { status: res.status, ok: res.ok, data };
}

export async function getById(userGroupId) {
    const res = await fetch(`${BASE_URL}/api/administration/accessUserGroup/${userGroupId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    });

    const text = await res.text();

    let data = null;

    try {
        data = text ? JSON.parse(text) : null;
    }
    catch {
        data = null;
    }

    if (!res.ok) {
        throw new Error(`Failed to fetch users: ${res.status}`);
    }

    return { status: res.status, ok: res.ok, data };
}

export async function create(userGroupObject) {
    const res = await fetch(`${BASE_URL}/api/administration/accessUserGroup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userGroupObject),
    });

    if (!res.ok) {
        const text = await res.text();
        let detail = '';
        try {
            const body = text ? JSON.parse(text) : null;
            if (body?.details?.length) {
                detail = ': ' + body.details.join(', ');
            } else if (body?.message) {
                detail = ': ' + body.message;
            }
        } catch {
            // ignore parse errors
        }
        throw new Error(`Failed to create user group (${res.status})${detail}`);
    }

    return res.json();
}

export async function update(userGroupId, userGroupObject) {
    const res = await fetch(`${BASE_URL}/api/administration/accessUserGroup/${userGroupId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userGroupObject),
  });

  if (!res.ok) {
    throw new Error(`Failed to update user: ${res.status}`);
  };

  return { status: res.status, ok: res.ok };
}

export async function patch(id, updates) {
    const res = await fetch(`${BASE_URL}/api/administration/accessUserGroup/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates),
    });
    
    if (!res.ok) {
        throw new Error(`Failed to update user group: ${res.status}`);
    };

    return { status: res.status, ok: res.ok }
}

export async function remove(userGroupId) {
    const res = await fetch(`${BASE_URL}/api/administration/accessUserGroup/${userGroupId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' }
    });
    
    if (!res.ok) {
        throw new Error(`Failed to delete a user group: ${res.status}`);
    }

    return { status: res.status, ok: res.ok };
}